// extracted by mini-css-extract-plugin
export var askAiIcon = "_mc-j";
export var category = "_mc-9";
export var categoryHeader = "_mc-e";
export var container = "_mc-0";
export var group = "_mc-a";
export var groupItems = "_mc-f";
export var groupSeparator = "_mc-k";
export var loading = "_mc-1";
export var noResults = "_mc-3";
export var placeholder = "_mc-2";
export var resultContent = "_mc-5";
export var resultIcon = "_mc-c";
export var resultItem = "_mc-g";
export var resultMeta = "_mc-8";
export var resultSubtitle = "_mc-7";
export var resultSuffix = "_mc-i";
export var resultTitle = "_mc-6";
export var resultsList = "_mc-4";
export var searchGroup = "_mc-d";
export var selected = "_mc-h";
export var subgroup = "_mc-b";